export default {
  labels: {
    in_store_card_payments_not_supported: '⚠️ Nur Barzahlung im Restaurant. Kartenzahlung nicht möglich.',
  },
};
